const getTheFirstLetterOfEachWord = (value: string) => {
  if (!value) {
    return '';
  }
  const collectionOfFirstLetters = value.match(/\b(\w)/g);
  return collectionOfFirstLetters?.join('');
};

export { getTheFirstLetterOfEachWord };
